var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"TheHistory"},[_c('GridRow',[_c('div',{staticClass:"TheHistory__Col"},[_c('div',{staticClass:"TheHistory__Image"},[_c('BaseImage',{attrs:{"src":_vm.image.src,"alt":_vm.image.alt}})],1)]),_c('div',{staticClass:"TheHistory__Col"},[_c('div',{staticClass:"TheHistory__Text"},[_c('BaseText',{attrs:{"text":_vm.text}})],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }